module.exports = __webpack_public_path__ + "static/media/star.dedb6f88.svg";